import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import VideoSource from '../VideoSource';
import './style.scss';

class Card extends PureComponent {
  render() {
    const { item } = this.props;
    const imageURL = `url(${item.largeImage || item.image})`;

    return (
      <div styleName="item">
        <div styleName="image">
          <Link to={`/detail/${item.id}`}>
            {item.videoId
              ? (
                <VideoSource
                  videoSrc={item.videoUrl}
                  width={260}
                  height={207}
                  placeholder={item.image}
                  title={item.title}
                />
              )
              : (<div styleName="img" style={{ backgroundImage: imageURL }} />)}
          </Link>
        </div>

        <div styleName="name">
          <Link to={`/detail/${item.id}`}>
            <h4 dangerouslySetInnerHTML={{ __html: item.title }}></h4>
          </Link>
        </div>

        <div styleName="last">
          <span styleName="author">
            <Link>{item.author}</Link>
          </span>
          <div styleName="icon">
            <div styleName="comment">
              <Icon icon="comment" size={16} alt="comment" />
            </div>
            <div styleName="heart">
              <Icon icon="share" size={16} alt="share" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Card.propTypes = {
  item: PropTypes.object.isRequired,
};

export default Card;
